import { isDefined } from '@zorro/common-utils';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Group, Text } from '@zorro/web/design-system';
import { estimateTextWidth } from '@zorro/web/ui-utils';

type TableTextCellProps = {
  value: string | null;
  widthThreshold?: number;
  maxTooltipWidth?: number;
};

/**
 * Renders a single-line, truncated text value for a data-table cell. When the
 * text is wider than `widthThreshold` it is shown with an ellipsis and the full
 * value is revealed in a tooltip on hover. Empty values render as a dash.
 */
export function TableTextCell({
  value,
  widthThreshold = 100,
  maxTooltipWidth = 500,
}: TableTextCellProps) {
  if (!value) {
    return <Text size="sm">-</Text>;
  }

  return (
    <Tooltip
      label={value}
      position="top"
      maw={maxTooltipWidth}
      multiline
      disabled={isDefined(value) && estimateTextWidth(value) < widthThreshold}
    >
      <Group pos="relative" style={{ flexWrap: 'nowrap' }}>
        <Text
          size="sm"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Text>
      </Group>
    </Tooltip>
  );
}
